export const isToday = (date) => {
  const today = new Date();

  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export const isWithinXDays = (date, days) => {
  const today = new Date();
  const targetDate = new Date(date);
  const diffTime = Math.abs(today - targetDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays <= days;
};

export const isWithinXMonths = (date, months) => {
  const today = new Date();
  const targetDate = new Date(date);
  const diffMonths =
    (today.getFullYear() - targetDate.getFullYear()) * 12 +
    today.getMonth() -
    targetDate.getMonth();

  return diffMonths <= months;
};

export const isWithinXYears = (date, years) => {
  const today = new Date();
  const targetDate = new Date(date);
  const diffYears = today.getFullYear() - targetDate.getFullYear();

  return diffYears <= years;
};

export const isWithinDateRange = (date, startDate, endDate) =>
  date >= startDate && date <= endDate;

/**
 * 빠른 기간 버튼(오늘/1주/1·3·6개월/1년) 또는 직접 입력한 날짜 범위로 목록을 필터.
 *
 * @param dateButtonClicked 6칸 boolean 배열 (오늘, 1주, 1개월, 3개월, 6개월, 1년)
 * @param getDate           항목 → 비교할 Date
 */
export const applyDateFilter = ({
  data,
  dateButtonClicked,
  startDate,
  endDate,
  getDate,
}) => {
  if (dateButtonClicked[0]) {
    return data.filter((item) => isToday(getDate(item)));
  }
  if (dateButtonClicked[1]) {
    return data.filter((item) => isWithinXDays(getDate(item), 7));
  }
  if (dateButtonClicked[2]) {
    return data.filter((item) => isWithinXMonths(getDate(item), 1));
  }
  if (dateButtonClicked[3]) {
    return data.filter((item) => isWithinXMonths(getDate(item), 3));
  }
  if (dateButtonClicked[4]) {
    return data.filter((item) => isWithinXMonths(getDate(item), 6));
  }
  if (dateButtonClicked[5]) {
    return data.filter((item) => isWithinXYears(getDate(item), 1));
  }
  if (startDate && endDate) {
    return data.filter((item) =>
      isWithinDateRange(getDate(item), new Date(startDate), new Date(endDate)),
    );
  }

  return data;
};
